module.exports = __webpack_public_path__ + "img/img38.73df74e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img38.jpg
// module id = 336
// module chunks = 0